import { useMutation } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest } from '../utils/graphqlClient';
import {
  profileQueryKeys,
  useProfileMutationFeedback,
} from './useProfileMutationFeedback';

const upsertTravelDocumentMutation = graphql(/* GraphQL */ `
  mutation upsertTravelDocument($input: UserTravelDocumentInput!) {
    upsertTravelDocument(input: $input)
  }
`);

export type UserTravelDocumentInput = {
  documentId: number;
  userId: string;
  countryOfIssuance: string;
  passportNumber: string;
  expiryDate: string;
};

const useUpsertTravelDocument = () => {
  const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();
  const userId = user?.sub ?? '';
  const feedback = useProfileMutationFeedback({
    successMessage: 'Passport details saved',
    queryKeys: [profileQueryKeys.travelDocument(userId)],
  });

  return useMutation({
    mutationFn: async (input: UserTravelDocumentInput) => {
      if (!isAuthenticated) {
        throw new Error('User must be authenticated to upsert travel document');
      }
      return graphqlRequest(
        upsertTravelDocumentMutation,
        { input },
        getAccessTokenSilently,
      );
    },
    ...feedback,
  });
};

export default useUpsertTravelDocument;
